import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Circular from '../Circular/Circular';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { getLastOrdersSlot } from '../../services/slots/slots';
import Moment from 'react-moment';
import moment from 'moment';
Moment.globalMoment = moment
Moment.globalLocale = 'pt-br'


const useStyles = theme => ({
    iconView : {
      color: "gray !important"
    },
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: 600
        }
    },
    note: {
        lineHeight: '0.9em'
    },
    dialog: {
        '& .MuiPaper-root':{
            margin: theme.spacing(1),
            width: 250,
            height: 150  
        }
    },
    dialogInfo: {
        '& .MuiDialog-paperWidthSm':{
            margin: theme.spacing(1),
            maxWidth: 900 
        }
    },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    red: {
        '& label.Mui-focused': {
            color: 'red'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'red',
        }
    }
  });

class ViewSlot extends Component {
    constructor(props) {
        super(props);
        this.getLastOrdersSlot = this.getLastOrdersSlot.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.compare = this.compare.bind(this);

        this.state = {
            waiting: true,
            error: false,
            data: [],
            color: ["success", "warning", "info"]
        }
    }

    componentDidMount() {
        this.getLastOrdersSlot();
    }

    getLastOrdersSlot = () => {

        getLastOrdersSlot(this.props.lockerId, this.props.slot.id, (data) => {
            let dataSorted = data.sort(this.compare);
            if(dataSorted.length > 3) {
                let newData = []
                for (let index = 0; index < 3; index++) {
                    newData.push(dataSorted[index]);
                }
                
                dataSorted = newData;
            }
            
            this.setState({ waiting: false, data: dataSorted });
        });

    }

    compare(a, b) {
        if (Date.parse(a.createdAt) < Date.parse(b.createdAt)) {
          return 1;
        }
        if (Date.parse(a.createdAt) > Date.parse(b.createdAt)) {
          return -1;
        }
        return 0;
      }

    handleClose = () => {
        this.props.onChange(false);
    };

    render() {
        const { classes } = this.props;
        const { data, color } = this.state;

        return (
            <div>
                <Dialog className={(this.state.waiting) ? classes.dialog : (data.length > 0) ? classes.dialogInfo : null}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                    {(this.state.waiting) ? <div><Circular/></div> : 
                    <GridContainer>
                        {(data.length > 0) ? data.map((d, index, arr) => (
                            <GridItem xs={12} sm={12} md={12/arr.length}>
                                <Card>
                                    <CardHeader color={color[index]}>
                                        <h4>Encomenda Id: {d.id.substring(5,10).toUpperCase()}</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <p className={classes.note}>Status: <p><b>{d.status}</b></p></p>
                                    <p className={classes.note}>Tamanho: <p><b>{d.size}</b></p></p>
                                    <p className={classes.note}>Token de Coleta: <p><b>{(d.collectToken) ? d.collectToken : '-'}</b></p></p>
                                    <p className={classes.note}>Atualizado em: <p><b>{(d.updatedAt) ? <Moment format="DD/MM/YYYY HH:mm:SS">{d.updatedAt}</Moment> : '-'}</b></p></p>
                                    <p className={classes.note}>Reservado em: <p><b>{(d.reservedAt) ? <Moment format="DD/MM/YYYY HH:mm:SS">{d.reservedAt}</Moment> : '-'}</b></p></p>
                                    <p className={classes.note}>Alocado em: <p><b>{(d.allocatedAt) ? <Moment format="DD/MM/YYYY HH:mm:SS">{d.allocatedAt}</Moment> : '-'}</b></p></p>
                                    <p className={classes.note}>Coletado em: <p><b>{(d.collectedAt) ? <Moment format="DD/MM/YYYY HH:mm:SS">{d.collectedAt}</Moment> : '-'}</b></p></p>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        )) : <p className={classes.note}>Nenhuma encomenda anterior!</p> }
                    </GridContainer>}
                    </DialogContent>
                    <DialogActions>
                    {(this.state.waiting) ? null :
                    <div><Button onClick={this.handleClose} color="primary">
                        Voltar
                    </Button></div>}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(useStyles)(ViewSlot);